export const languageChannel = new BroadcastChannel("language_channel");

export function broadcastLanguageChange(lang: string) {
  languageChannel.postMessage({ lang });
}
